<template>
  <div style="min-height: 92vh">
    <div>
      <h3>Categorias de Productos</h3>
      <uv-data-table :config="config" :data="Categories" :pageRows="15" @buttonClick="dtButtonClick"></uv-data-table>
    </div>
    <modal v-model="showModal" :showFooter="false" title="Categorias">
      <cateForm :edit="editMode" @toggle="toggleModal" :key="formIndex" :familias="familias" :dataEdit="editData"
        @successData="successData">
      </cateForm>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import { mapActions, mapGetters } from "vuex";

import uvDataTable from "../../MainComponents/DataTable.vue";
import cateForm from "../Categorias/CategoriasForm.vue";

export default {
  name: "CategoriasCRUD",
  components: {
    modal,
    uvDataTable,
    cateForm,
  },
  props: [],
  data() {
    return {
      self: this,
      showModal: false,
      formKey: 0,
      Categories: [],
      formIndex: 0,
      editMode: false,
      familias: [],
      editData: [],
      zonas: [],
      config: {
        selectableRow: true,
        allowExport: true,
        rawText: "Categorias",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addCategoria",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editCategoria",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteCategoria",
            require: true,
          },
        ],
        fields: [
          {
            title: "Nombre",
            dataName: "Nombre",
            text: "Nombre",
            value: "Nombre",
          },
          {
            canBeFiltered: true,
            text: "Oculto en PDV",
            value: "Hide",
            format: (row) => {
              if (row.Hide) {
                return "Oculto";
              } else {
                return "";
              }
            },
          },
          {
            text: "Familia",
            value: "Familia",
            dataName: "Familia",
            format: (row) => {
              let data = this.$pgsHelper.getById(this.familias, "id", row.Familia);
              return data ? data.Nombre : "-";
            }
          },

          {
            canBeFiltered: true,
            text: "Zona Impresión",
            value: "ZImp",
            format: (row) => {
              let data = this.$pgsHelper.getById(this.zonas, "Id", row.ZImp);
              return data.nomb;
            },
          },
          {
            canBeFiltered: true,
            title: "Departamento",
            dataName: "Departamento",
            text: "Departamento",
            value: "Departamento",
          },
        ],
      },
    };
  },
  methods: {
    async getZonasImpresion() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "/PDV/ZonasImpresion"
        );
      if (snapshot.exists()) {
        this.zonas = [];
        this.zonas.push({ Id: "TICKET-PRINTER", nomb: "Default" });
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            this.zonas.push(toAdd);
          }
        });
      }
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addCategoria") {
        this.formIndex++;
        this.editMode = false;
        this.showModal = true;
      }
      if (buttonId == "deleteCategoria") {
        this.deleteCategoria(idSelected[0]);
      }
      if (buttonId == "editCategoria") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.getCategoryById(idSelected[0]);
        this.$pgsHelper.log(this.editData);
        this.showModal = true;
      }
    },
    getCategoryById(code) {
      let itemIndex = this.$_.findIndex(this.Categories, { id: code });
      if (itemIndex >= 0) {
        return this.Categories[itemIndex];
      }

      return false;
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createCate(data);
      } else if (doAction == "EDIT") {
        this.editCate(data);
      }
    },
    createCate(datos) {
      this.$swal({
        title: "¿Deseas guardar la información de la categoria?",
        text: "La categoria se almacenara y podra ser asignada a los productos",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Categorias-createCategoria", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              title: "Guardado",
              text: "La categoria se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getCategories();
            });
          } else {
            this.$swal(
              "Error saving Categoria",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editCate(datos) {
      this.$pgsHelper.log(datos);

      this.$swal({
        title: "¿Deseas modificar la información de la categoria?",
        text: "La categoria se almacenara y podra ser usignada a los productos",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Categorias-updateCategoria", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              title: "Guardado",
              text: "La categoria se modifico correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getCategories();
            });
          } else {
            this.$swal(
              "Error saving Categoria",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    async deleteCategoria(id) {
      this.$swal({
        title: "¿Deseas eliminar esta categoria?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = { Id: id };
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Categorias-deleteCategoria", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Categoria elimando",
              "La Categoria se elimino correctamente",
              "success"
            );
            this.getCategories();
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getFamilias() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Productos/Familias"
        );

      this.familias = this.$pgsHelper.ArrayObjectToArray(data.val()) || [];
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      await this.fetchCategories();
      const claims = this.$route.params.user?.tokenResult?.claims;
      this.Categories = this.getCategoriesFiltered(claims);
    },
  },
  computed: {
    ...mapGetters("Categorias", ["getCategoriesFiltered"]),
  },
  watch: {},
  mounted() { },
  created() {
    this.getFamilias();
    this.getZonasImpresion();
    this.getCategories();
  },
};
</script>
